const styles = {
  wrapper: {
    display: "flex",
    minHeight: "100vh",
    width: "100vw",
    overflowX: "hidden",
  },
  sidebar: {
    width: "280px",
    background: "#0f172a",
    padding: "80px 24px",

    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    overflow: "visible", // 🔥 dropdown cut nahi hoga
    display: "flex",
    flexDirection: "column",

    transition: "0.4s ease",
    zIndex: 1002,

    // 🔥 ADD THIS
    overflowY: "auto",
    maxHeight: "100vh",
  },

  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "50px",
  },
  nav: { flexGrow: 1, display: "flex", flexDirection: "column", gap: "10px" },

  navItem: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center", // 🔥 center alignment
  gap: "10px",
  padding: "12px",
  fontSize: "15px", // 🔥 SAME SIZE
  fontWeight: 500,
  width: "100%",
  textAlign: "center",
  borderRadius: "12px",
  cursor: "pointer",
  color: "#c7d2fe",
},
 activeNavItem: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  padding: "12px",
  fontSize: "15px",
  fontWeight: 500,
  width: "100%",
  textAlign: "center",
  borderRadius: "12px",
  background: "rgba(139,92,246,0.2)",
  color: "#fff",
},
  sidebarFooter: {
    borderTop: "1px solid rgba(255,255,255,0.05)",
    paddingTop: "30px",
  },
  logoutBtn: {
    width: "100%",
    background: "none",
    border: "none",
    color: "#f43f5e",
    cursor: "pointer",
    display: "flex",
    gap: "12px",
    fontWeight: "300",
    alignItems: "center",
  },
  main: {
    flexGrow: 1,
    width: "100%",
    overflowX: "hidden",
  },
  header: {
    height: "90px",
    background: "#0f172a",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 20px",
    position: "fixed", // 🔥 FIXED
    top: 0,
    left: 0,
    right: 0,
    zIndex: 999, // 🔥 above everything
  },

  profileBadge: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    background: "rgba(255,255,255,0.1)",
    padding: "8px 15px",
    borderRadius: "50px",
  },
  avatarWrapper: {
    width: "35px",
    height: "35px",
    background: "linear-gradient(45deg, #ec4899, #8b5cf6)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    // marginTop:"80px",
    padding: "clamp(16px, 4vw, 40px)", // ✅ auto responsive padding
  },

  sectionTitle: { fontSize: "32px", fontWeight: "300", color: "#0f172a" },
  subText: { color: "#64748b", fontWeight: "700", marginTop: "5px" },
  emailSpan: { color: "#8b5cf6", fontWeight: "600" },

  statsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(150px, 1fr))", // ✅ responsive
    gap: "16px",
    marginTop: "20px",
    maxWidth: "100%",
  },

  statCard: {
    background: "#fff",
    padding: "25px",
    borderRadius: "25px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    border: "1px solid #f1f5f9",
  },
  iconBox: {
    width: "55px",
    height: "55px",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  statLabel: { fontSize: "10px", color: "#94a3b8", fontWeight: "300" },
  statValue: { fontSize: "20px", fontWeight: "300", color: "#0f172a" },
  lockBadge: {
    background: "#8b5cf6",
    color: "#fff",
    padding: "10px 20px",
    borderRadius: "12px",
    fontSize: "13px",
    border: "none",
    fontWeight: "300",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    zIndex: 10,
  },

  cardsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    width: "100%",
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "40px 20px", // 🔥 row-gap | column-gap
    alignItems: "stretch",
  },

  glamourCard: {
    width: "100%",
    background: "#fff",
    borderRadius: "16px",
    padding: "18px",
    boxShadow: "0 8px 24px rgba(0,0,0,.08)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  cardLine: {
    height: "4px",
    width: "100%",
    borderRadius: "4px",
    marginBottom: "12px",
  },

  innerRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "6px",
  },

  innerLabel: {
    fontSize: "11px",
    fontWeight: 500,
    color: "#64748b",
  },

  innerValue: {
    fontSize: "12px",
    fontWeight: 500,
  },

  badge: {
    fontSize: "11px",
    fontWeight: 500,
    padding: "2px 8px",
    borderRadius: "6px",
    background: "#ede9fe",
    color: "#6d28d9",
  },

  divider: {
    height: "1px",
    background: "#e5e7eb",
    margin: "10px 0",
  },

  footerText: {
    marginTop: "10px",
    fontSize: "10px",
    fontWeight: 500,
    color: "#94a3b8",
    letterSpacing: "1px",
  },
  chartGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "25px",
    marginTop: "30px",
  },
  chartBox: {
    background: "#fff",
    padding: "25px",
    borderRadius: "25px",
    border: "1px solid #f1f5f9",
  },
  chartTitle: {
    fontSize: "16px",
    fontWeight: "300",
    color: "#1e1b4b",
    marginBottom: "20px",
  },
  loader: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f8fafc",
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15, 23, 42, 0.4)",
    backdropFilter: "blur(8px)",
    zIndex: 1000,
  },
  page: {
    marginTop: "40px",
    // overflowX: 'auto',
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", // ✅ responsive
    gap: "20px",
    alignItems: "stretch",
  },

  profileImageWrapper: {
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #a78bfa",
  },

  profileImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  profileText: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.1,
  },

  profileName: {
    color: "#fff",
    fontWeight: "300",
    fontSize: "13px",
  },

  profilePlan: {
    color: "#c7d2fe",
    fontSize: "11px",
    fontWeight: "300",
  },

  dropdown: {
    padding: "12px 14px",
    borderRadius: 16,
    border: "1px solid #e2e8f0",

    background: "linear-gradient(145deg,#ffffff,#f8faff)",

    fontSize: 14,
    fontWeight: 500,
    color: "#0f172a",

    cursor: "pointer",
    outline: "none",
    width: "100%",

    boxShadow: "0 6px 16px rgba(0,0,0,.06)",

    transition: ".25s",
  },

  // Styles object mein ye fix karein (Last section of your code)
  profileImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  profileText: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
  },
  profileName: {
    color: "#fff",
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "1.2",
  },
  profilePlan: {
    color: "#a78bfa",
    fontSize: "10px",
    fontWeight: "300",
  },
  dropdown: {
    padding: "10px 15px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0",
    backgroundColor: "#fff",
    fontSize: "14px",
    fontWeight: "300",
    color: "#1e293b",
    appearance: "none", // Remove default arrow
    cursor: "pointer",
    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
  },
  userBadge: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "6px 14px",
    background: "rgba(255,255,255,0.12)",
    borderRadius: 999,
    cursor: "pointer",
    backdropFilter: "blur(10px)",
    boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
    width:"140px"
  },

  userAvatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #8b5cf6",
  },

  userMeta: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.1,
  },

  userName: {
    color: "#fff",
    fontSize: 13,
    fontWeight: 500,
    maxWidth: 120,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  planPill: {
    fontSize: 10,
    fontWeight: 500,
    padding: "2px 8px",
    borderRadius: 999,
    color: "#fff",
    width: "fit-content",
    marginTop: 2,
  },
  userDropdown: {
    position: "absolute",
    top: "120%",
    right: 0,
    background: "#0f172a",
    borderRadius: 14,
    minWidth: 180,
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)",
    overflow: "hidden",
    zIndex: 9999,
  },

  dropdownItem: {
    padding: "14px 18px",
    fontSize: 13,
    fontWeight: 500,
    color: "#e5e7eb",
    cursor: "pointer",
    transition: "0.25s",
  },

  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "18px",
  },

 headerItem: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center", // 🔥 center

  gap: "10px",

  fontSize: "15px", // 🔥 SAME SIZE
  fontWeight: 500,

  width: "100%",
  textAlign: "center",

  color: "#c7d2fe",
  cursor: "pointer",
},

  reportDropdown: {
    position: "absolute",

    top: "100%", // 🔥 BUTTON KE EXACT NEECHE
    left: 0,

    width: "100%", // 🔥 sidebar jitna
    minWidth: "240px",

    background: "#0f172a",
    borderRadius: 14,

    zIndex: 99999,

    marginTop: "6px", // 🔥 gap

    maxHeight: "220px",
    overflowY: "auto",

    boxShadow: "0 16px 32px rgba(0,0,0,.35)",

    animation: "dropFade .25s ease",
  },

  reportTitle: {
    fontSize: 13,
    fontWeight: 500,
    color: "#a5b4fc",
    padding: "8px 10px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },

  reportItem: {
    padding: "10px 12px",
    fontSize: 13,
    fontWeight: 500,
    color: "#e5e7eb",
    cursor: "pointer",
    borderRadius: 10,
    marginTop: 6,

    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",

    transition: ".2s",
  },

  reportTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: "#a5b4fc",
    padding: "8px 10px",
    borderBottom: "1px solid rgba(255,255,255,0.1)",
  },

  whitePanel: {
    background: "#fff",
    borderRadius: "999px",
    padding: "10px 24px",
    display: "flex",
    alignItems: "center",
    gap: "26px",
    boxShadow: "0 8px 20px rgba(0,0,0,.12)",
  },

  statBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "90px",
  },

  bigNumber: {
    fontSize: "20px",
    fontWeight: 500,
    color: "#6b21a8",
  },

  smallText: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#64748b",
  },

  verdictText: {
    fontSize: "15px",
    fontWeight: 700,
  },

  dotRow: {
    display: "flex",
    gap: "8px",
    marginLeft: "6px",
  },

  dot: {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
  },

  filter: "drop-shadow(0 6px 14px rgba(124,58,237,.35))",



  
};





export default styles;